module.exports = __webpack_public_path__ + "static/media/film-production-grid-2.5fdfa258.jpg";